<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{
        item ? "Изменить товар" : "Добавить товар"
      }}</span>
    </v-card-title>
    <v-card-text>
      <v-text-field
        label="Название"
        placeholder=""
        filled
        v-model="name"
      ></v-text-field>

      <v-text-field
        label="ID у партнёра"
        placeholder=""
        filled
        v-model="externalId"
      ></v-text-field>

      <v-select
        :items="categories"
        filled
        label="Категория"
        item-text="name"
        item-value="id"
        v-model="category"
        multiple
      ></v-select>

      <v-btn color="primary" @click="submit" class="mr-5">Сохранить</v-btn>
      <v-btn @click="$emit('close')">Отмена</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "goods-form",
  props: ["item", "categories"],
  data() {
    return this.item ? {
      externalId: this.item.externalId || "",
      name: this.item.name || "",
      category: this.item.category
    } : {
      externalId: "",
      name: "",
      category: []
    };
  },
  methods: {
    submit() {
      this.$emit("submit", {
        externalId: this.externalId,
        name: this.name,
        category: this.category
      });
    }
  }
};
</script>
